import { render, staticRenderFns } from "./OrdenCompraReporte2.vue?vue&type=template&id=91b653c6&scoped=true&"
import script from "./OrdenCompraReporte2.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraReporte2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b653c6",
  null
  
)

export default component.exports